export const formatDate = (input: Date | string): string => {
	const date = typeof input === "string" ? new Date(input) : input;

	if (isNaN(date.getTime())) {
		throw new Error("Invalid date input");
	}

	const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric', numberingSystem: "latn" };
	const newDate = date.toLocaleDateString('ar-EG', options).split(" ");
	// There is a strange "،" in the month name, so we remove it
	return `${newDate[1].replace("،", "")} ${newDate[0]}, ${newDate[2]}`;
}